import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { cn } from '../../lib/utils';
const FAQS = [{
  q: 'When should I have a contract reviewed?',
  a: 'Before signing or bidding wherever possible. A review can identify conditions, disclosures and transaction risks that may affect your decision or require further advice.'
}, {
  q: 'What is a vendor disclosure statement?',
  a: 'It is information a seller may need to provide to a buyer before signing. The document and disclosure requirements differ between states and territories, so the contract and relevant disclosure material should be reviewed together.'
}, {
  q: 'Can you help with an auction purchase?',
  a: 'The contract should ideally be reviewed before auction day because auction contracts are generally unconditional once the property is purchased. Send the contract and auction date with your enquiry.'
}, {
  q: 'Can you assist with an SMSF or trust purchase?',
  a: 'The existing practice information lists SMSF, family trust and unit trust property transactions. These matters commonly require coordination between the legal team, accountant, adviser and lender.'
}, {
  q: 'How quickly can a contract be reviewed?',
  a: 'Timing depends on the document, transaction and current workload. Include your signing or auction deadline when submitting the contract so the team can assess urgency.'
}, {
  q: 'Do I need a property lawyer or a conveyancer?',
  a: 'Both lawyers and licensed conveyancers can manage conveyancing work within their authorised scope. A property lawyer can also advise on broader legal issues when a transaction becomes more complex.'
}, {
  q: 'How much does conveyancing cost in Australia?',
  a: 'Fees depend on the property and the transaction, so we provide a confirmed fixed scope and fee in writing before any work begins. There is no cost to send a contract or request a quote, and no obligation to proceed.'
}, {
  q: 'What cooling-off period applies when buying property?',
  a: 'Cooling-off periods and exceptions differ between states and territories, and auction purchases may be treated differently. Check the contract and obtain advice for the property location before signing.'
}, {
  q: 'What checks happen before settlement?',
  a: 'Before settlement the team reviews the title and any encumbrances, confirms adjustments for rates and outgoings, prepares and verifies settlement figures, and coordinates the date and requirements with the other party. You are kept informed as the matter reaches completion.'
}, {
  q: 'Do I need a lawyer for an off-the-plan purchase?',
  a: 'Off-the-plan contracts can be longer and more complex, with disclosure, sunset dates and variation clauses that benefit from legal review before you sign. Send the contract and any deadline with your enquiry.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 md:py-14 px-5 md:px-6 bg-cream" data-id="element-245" data-mp="3ksyewxz0vyhr">
      <div className="max-w-3xl mx-auto" data-id="element-246" data-mp="3kurlkd9myipr">
        <div className="text-center mb-6 md:mb-8" data-id="element-247" data-mp="3pqqg6ilk4wym">
          <p className="eyebrow text-brand-blue mb-1" data-id="element-248" data-mp="3ptmbs09xn9jw">
            good to know
          </p>
          <h2 className="text-3xl md:text-[2.6rem] leading-tight text-ink" data-id="element-249" data-mp="3tr0k7ppshdau">
            Common property questions.
          </h2>
        </div>

        <div className="space-y-3" data-id="element-250" data-mp="322gxhpjn4pbp">
          {FAQS.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={cn('rounded-2xl border bg-surface overflow-hidden transition-colors', isOpen ? 'border-accent/40' : 'border-border')} data-id="element-251" data-mp="3642b5d4017my" data-mpi={i}>
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-inset" aria-expanded={isOpen} data-id="element-252" data-mp="2ieq1yd8o8zkn">
                  <span className="font-serif text-lg md:text-xl text-ink" data-id="element-253" data-mp="ox285onbgewn">
                    {faq.q}
                  </span>
                  <span className={cn('inline-flex w-8 h-8 items-center justify-center rounded-full shrink-0 transition-all duration-300', isOpen ? 'bg-accent text-white rotate-45' : 'bg-accent-soft text-accent')} data-id="element-254" data-mp="xvxed0qd1ozy">
                    <Plus className="w-4 h-4" strokeWidth={2.5} data-id="element-255" data-mp="1lkp0pbh9rd4t" />
                  </span>
                </button>
                <div className={cn('grid transition-all duration-300 ease-soft', isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0')} data-id="element-256" data-mp="1hhs9wxhksaps">
                  <div className="overflow-hidden" data-id="element-257" data-mp="399fm4807u4gd">
                    <p className="px-5 md:px-6 pb-6 text-muted-ink leading-relaxed" data-id="element-258" data-mp="3d969e1qja2g5">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}